import { Grid } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import DataGridGenerico from "../../../components/dataGrid/DataGridGenerico";
import { usePersistFilters } from "../../../hooks/usePersistFilters";
import { useGestionAsistencialInputs } from "../../GestionAsistencial/hooks/useGestionAsistencialInputs";
import { useEnviosRows } from "../hooks/useEnviosRows";
import { useGestionEnviosColumns } from "../hooks/useGestionEnviosColumns";
import { GestionEnviosFiltersHeader } from "./GestionEnviosFiltersHeader";
import { GestionEnviosTabs } from "./GestionEnviosTabs";


export const TAB_AUTORIZAR_ID = 0;
export default function GestionEnviosContent() {
  const location = useLocation();
  const { activeTab = 0 } = location?.state || {};

  const [delegaciones, setDelegaciones] = useState([]);
  const [isRefetchRequired, setIsRefetchRequired] = useState(false);
  const [initialValues, setInitialValues] = useState({
    idDelegacion: 0,
    fechaDesde: "",
    fechaHasta: "",
  });

  const [tabs, setTabs] = useState([
    { id: 0, enumValue: 1, enumName: 'AUTORIZAR', name: 'Envíos a autorizar', active: activeTab === 0, count: 0 },
    { id: 1, enumValue: 2, enumName: 'AUTORIZADOS', name: 'Envíos autorizados', active: activeTab === 1, count: 0 },
  ]);

  const { filters, handleChangeFilters } = usePersistFilters(
    {
      idDelegacion: 0,
      txtFiltro: ""
    },
    "EnviosFilters"
  );

  const [activeTabId, estadoEnvio] = useMemo(() => {
    const selectedTab = tabs.find(tab => tab.active);
    return [selectedTab?.id, selectedTab?.enumValue];
  }, [tabs]);

  const nombreDelegacion = useMemo(
    () =>
      delegaciones?.find((d) => d.id === filters?.idDelegacion)?.displayName,
    [filters?.idDelegacion, delegaciones]
  );

  const columns = useGestionEnviosColumns(
    nombreDelegacion,
    filters?.idDelegacion,
    activeTabId
  );

  const resetInitialValues = () => {
    setInitialValues({
      idDelegacion: filters.idDelegacion,
    });
    setIsRefetchRequired(false);
  };

  const {
    rows,
    setRows,
    originalDataAutorizar,
    originalDataAutorizados,
    totalCount,
    loading,
    handleSearch,
    applyClientSideFilters,
  } = useEnviosRows({
    filters,
    estadoEnvio,
    activeTabId,
    handleChangeFilters,
    resetInitialValues,
  });

  const { handleChange, handleChangeFechaDesde, handleChangeFechaHasta } =
    useGestionAsistencialInputs({
      handleChangeFilters,
      initialValues,
      setIsRefetchRequired,
    });

  const handleTextFilter = () => {
    const data = applyClientSideFilters(
      (activeTabId === TAB_AUTORIZAR_ID ? originalDataAutorizar : originalDataAutorizados),
      filters.txtFiltro,
    );
    setRows(data);
  };

  const handleTextClean = () => {
    handleChangeFilters("txtFiltro", "");
    const data = applyClientSideFilters(
      (activeTabId === TAB_AUTORIZAR_ID ? originalDataAutorizar : originalDataAutorizados),
      "",
    );
    setRows(data);
  };

  const handleDelegacionChange = (event) => {
    const newDelegacion = event.target.value;
    handleChange(event);

    if (newDelegacion !== initialValues.idDelegacion) {
      setIsRefetchRequired(true);
      setRows([]);
      return;
    }

    setIsRefetchRequired(false);
  };

  useEffect(() => {
    setInitialValues({
      idDelegacion: filters.idDelegacion,
    });
  }, []);

  return (
    <div className="grid-container requisitos-clientes-grilla">
      <GestionEnviosFiltersHeader
        filters={filters}
        handleChange={handleChange}
        handleTextClean={handleTextClean}
        handleTextFilter={handleTextFilter}
        handleSearch={handleSearch}
        handleDelegacionChange={handleDelegacionChange}
        handleChangeFechaDesde={handleChangeFechaDesde}
        handleChangeFechaHasta={handleChangeFechaHasta}
        delegaciones={delegaciones}
        setDelegaciones={setDelegaciones}
      />
      <GestionEnviosTabs
        tabs={tabs}
        setTabs={setTabs}
        handleSearch={handleSearch}
        setRows={setRows}
        activeTabId={activeTabId}
        originalDataAutorizados={originalDataAutorizados}
        originalDataAutorizar={originalDataAutorizar}
      />
      <DataGridGenerico
        columns={columns}
        totalCount={totalCount}
        rows={rows}
        toolbar={false}
        loading={loading}
        localeText={{
          noRowsLabel: isRefetchRequired
            ? 'Haz click en "Buscar" para aplicar los nuevos filtros'
            : "Sin filas",
        }}
      />
      <div className='card-container' style={{ marginTop: '20px', fontWeight: 'normal' }}>
        <Grid
          container
          justifyContent={'flex-start'}
          rowGap={1}
        >
          <Grid size={{ md: 12 }}>
            <div className='titulo-seccion'>Referencias</div>
          </Grid>
          <Grid size={{ md: 12 }}>
            <strong>UME% = 0%:</strong> No tiene indicacion o no tiene envios realizados           
          </Grid>
          <Grid size={{ md: 12 }}>
            <strong>{'UME%<100%:'}</strong> Lo suminstrado es inferior a lo indicado
          </Grid>
          <Grid size={{ md: 12 }}>
            <strong>C:</strong> Costo de Dieta Diaria
          </Grid>
          <Grid size={{ md: 12 }}>
            <strong>N:</strong> Cantidad de Envios
          </Grid>
          <Grid size={{ md: 12 }}>
            <strong>J:</strong> Justificacion condicional
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
